import { 
  Row, Col, Card, Modal, Input, notification, Progress, Form, 
  TreeSelect, Select, Cascader, Button, DatePicker, Switch, Tooltip, Upload, InputNumber, Badge, Popconfirm
} from "antd";
import React, { useEffect, useState } from "react";
import { Map, APILoader, Marker } from '@uiw/react-baidu-map';
import { gaEvent } from "../../withTracker";
import { 
  getDeviceLocations, modifyDeviceName, addAndroidDevice, 
  setDeviceRemarks, deviceExcludes, bypassActivationlock, updateDeviceUser, updateDeviceOrg, iosDeviceOperation,getDeviceBypassCode
} from "../../axios/api.device";
import { getOrganizationTree, getTagListByStatic, getAllUserList } from "@axios/api.account";
import { OrganizationNodepProps, TagProps } from "@axios/models";
import { DataNode } from "antd/lib/tree";
import { getAssetAll, setDeviceAsset } from "../../axios/api.asset";
import {
  EditOutlined, InfoCircleOutlined, UploadOutlined
} from "@ant-design/icons";
import {
  DeviceTypes,
} from "../models";
import dayjs from 'dayjs';

import { Translation, useTranslation } from "react-i18next";
import i18n from "@src/locales";
import { DefaultOptionType } from "antd/lib/cascader";
import { RootStoreModel } from "@redux/reducers";
import { useSelector } from "react-redux";
import { platform } from "os";

interface propsModel {
  data: any;
  id: string;
}
const { Item, List } = Form;
const { TextArea } = Input;
const dateFormat = 'YYYYMM';
const dateFormat2 = 'YYYYMMDD';

export const DeviceDetailOverview = (props: propsModel) => {
  const { data, id } = props;
  const [locations, setLocations] = useState<any[]>();
  const [tagOptions, setTagOptions] = useState<any[]>();
  const [orgOptions, setOrgOptions] = useState<any[]>();
  const [bypassCode, setBypassCode] = useState<string>();
  const [form] = Form.useForm();
  const [assetForm] = Form.useForm();
  const [noteForm] = Form.useForm();
  const [userForm] = Form.useForm();
  const [orgForm] = Form.useForm();
  const [orgName, setOrgName] = useState<string>();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalVisible2, setIsModalVisible2] = useState(false);
  const [userVisible, setUserVisible] = useState(false);
  const [orgVisible, setOrgVisible] = useState(false);
  const [assetVisible, setAssetVisible] = useState(false);
  const [noteVisible, setNoteVisible] = useState(false);
  const [tagValues, setTagValues] = useState<any[]>();
  const [users, setUsers] = useState<any[]>();
  const [userName, setUserName] = useState<string>();
  const [userSelect, setUserSelect] = useState<string>();
  const [assetList, setAssetList] = useState<any[]>([]);
  const [marker, setMarkers] = useState<any>();
  const [deviceName, setDeviceName] = useState<any>();
  const [deviceNameVisible, setDeviceNameVisible] = useState<boolean>();
  const [ActivationlockVisible, setActivationlockVisible] = useState<boolean>(false);
  const [imageUrl, setImageUrl] = useState<any>();
  const [fdeFileVisible, setFDEFileVisible] = useState<boolean>(false);
  const user = useSelector((state: RootStoreModel) => state.userState);
  
  const { t } = useTranslation();

  useEffect(() => {
    getLocations();
    getOptions();
  }, []);

  const getLocations = () => {
    getDeviceLocations(id).then(
      (res) => {
        setLocations(res);
      }
    );
  };

  const getOptions = () => {
    Promise.all(
      [getTagListByStatic(), getOrganizationTree(), getAllUserList(), getAssetAll()]
    ).then(([res1, res2, res3, res4]) => {
      setTagValues(res1);
      const [tags, orgs] = formatOptions(res1, res2);
      setTagOptions(tags);
      setOrgOptions(orgs);
      setUsers(res3);
      setAssetList(res4);
    });
  };

  const formatOptions = (tags: TagProps[], orgs: OrganizationNodepProps[]) => {
    const resTags = tags.map(({ id, key, values }) => {
      return {
        value: id,
        label: key,
        children: values.map((item: any) => ({
          value: item.id,
          label: item.value,
        })),
      };
    });

    const formatData = (treeList: OrganizationNodepProps[]): DataNode[] => {
      return treeList.map((tree) => {
        const { id, name, level, sort, organizations } = tree;
        const children = formatData(organizations);
        return {
          title: name,
          key: id,
          value: id,
          // level: level,
          children: children,
        };
      });
    };
    const resOrgs = formatData(orgs);
    return [resTags, resOrgs];
  };

  const deviceNameModify = () => {
    if (!deviceName) {
      notification.warning({message: t("设备名称不能为空")});
      return
    }
    data.deviceName = deviceName;
    modifyDeviceName(id, deviceName).then(() => {
      notification.success({ message: t("修改成功") });
      setDeviceNameVisible(false);
    })
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };
  const handleOk2 = () => {
    setIsModalVisible2(false);
    var obj = form.getFieldsValue();
    const { tags } = obj;
    var tagIds: any[] = [];
    var selectVals: any[] = [];
    var tagsArray: any[] = [];
    if (Array.isArray(tags)) {
      tags.map((item) => {
        if (item) {
          const tagObj = item.tag;
          if (tagObj != undefined && tagObj?.length !== 0) {
            var tagId = tagObj[0];
            var tagValueId = tagObj[1];
            var tag = tagValues?.filter((v) => v.id == tagId)[0];
            if (tag) {
              var vals = tag.values;
              var val = Array.isArray(vals) ? vals.filter(v => v.id == tagValueId)[0].value : "";
              tagIds.push(tagValueId);
              selectVals.push(val);
            }
            tagsArray.push(item);
          }
        }
      })
    }
    data.currentTags = tagsArray;
    data.tagValues = selectVals;
    if (tagIds.length === 0) {
      data.currentTags = tagIds;
    }
    data.tags = tagIds;
    // updateTags(selectVals);
    addAndroidDevice({
      id: data.id,
      // organizationId: organization,
      // userId: userId,
      tags: tagIds,
    }).then(
      () => {
        notification.success({ message: t("修改成功") });
        getOptions();
      }
    );
  };

  const handleOrgOk = () => {
    setOrgVisible(false);
    data.organizationName = orgName;
    var obj = orgForm.getFieldsValue();
    const { organization } = obj;
    data.organizationId = organization;
    updateDeviceOrg(data.id,{
        organizationId: organization,
    }).then(
      () => {
        notification.success({ message: t("修改成功") });
        getOptions();
      }
    );
  };
  const handleUserOk = () => {
    setUserVisible(false);

    if(userSelect == "Create")
    {
      var userObj = userForm.getFieldsValue();
      //const {name,email,phone,remark} = userObj;
      const name = userObj.name ? userObj.name.trim() : '';
      const email = userObj.email ? userObj.email.trim() : '';
      const phone = userObj.phone ? userObj.phone.trim() : '';
      const number = userObj.number ? userObj.number.trim() : '';
      const orgName = userObj.orgName ? userObj.orgName.trim() : '';
      const remark = userObj.remark ? userObj.remark.trim() : '';
      if (!name) {
        notification.warning({message: t("姓名不能为空")});
        return;
      }
          updateDeviceUser(data.id,{
            name: name,
            email: email,
            phone: phone,
            remark: remark,
            number: number,
            orgName: orgName,
            isSelect: false
          }).then(
            (res) => {
              notification.success({ message: t("修改成功") });
              getOptions();
              setUserName(name);
              data.userName = name;
              data.userId = res;
            }
          );
    }
    else
    {
      var obj = userForm.getFieldsValue();
      const { userId } = obj;
      updateDeviceUser(data.id,{
        userId: userId,
        isSelect: true,
      }).then(
        () => {
          notification.success({ message: t("修改成功") });
          getOptions();
          data.userName = userName;
          data.userId = userId;
        }
      );
    }
  };

  const handleAssetOk = () => {
    assetForm.validateFields().then(res => {
      var arg: any = {};
      let tmp = res.extensions?.map((item: any) => {
        return {
          assetType: item.assetType,
          amount: item.amount,
          assetDate: item.assetDate,
          remark: item.remark
        }
      });
      arg.assetBeginDate = res.assetBeginDate ? res.assetBeginDate.format("yyyyMM") : 0;
      arg.assetId = res.assetId;
      arg.invoice = res.invoice;
      arg.invoiceFile = res.invoiceFile?.file;
      arg.extensions = JSON.stringify(tmp);
      
      data.assetBeginDate = arg.assetBeginDate;
      data.assetName = assetList.find(c => c.id == arg.assetId).name;
      data.assetId = res.assetId;
      setAssetVisible(false);
      setDeviceAsset(data.id, arg).then(() => {
        data.invoice = res.invoice;
        data.invoiceUrl = imageUrl;
        data.extensions = tmp;
        notification.success({ message: t("修改成功") });
      })
    })
  };

  const showModal = (location: any) => {
    setIsModalVisible(true);
    setMarkers(location);
  };

  const showModal2 = () => {
    //setOrgName(data.organizationName);
    form.setFieldsValue({ 
      //organization: data?.organizationId, 
      //userId: data?.userId, 
      tags: data?.currentTags 
    });
    setIsModalVisible2(true);
  };
   const showOrgModal = () => {
    setOrgName(data.organizationName);
    orgForm.setFieldsValue({ 
      organization: data?.organizationId
    });
    setOrgVisible(true);
  };
  const showUserModal = () => {
    var userSelect = data?.userName ? "Select":"Create";
    setUserSelect(userSelect);

    userForm.setFieldsValue({ 
      userId: data?.userId,
      userSelect: userSelect
    });
    setUserVisible(true);
  };
  const showAssetModal = () => {
    var assDate;
    if (data.assetBeginDate == 0) {
      assDate = dayjs(new Date(), dateFormat);
    } else {
      var assetBeginDate = data.assetBeginDate + "";
      assDate = dayjs(assetBeginDate, dateFormat);
    }    
    if (data?.invoiceUrl) {
      setImageUrl(data.invoiceUrl);
    }
    
    assetForm.setFieldsValue({
      assetId: data?.assetId,
      assetBeginDate: assDate,
      invoice: data?.invoice,
      invoiceFile: data?.invoiceUrl,
      extensions: data?.extensions?.map((item: any) => {
        return {
          assetType: item.assetType,
          assetDate: dayjs(item.assetDate, dateFormat),
          amount: item.amount,
          remark: item.remark,
        }
      }), 
    });
    setAssetVisible(true);
    
  };

  const isHidden = (platforms: string[]) => {
    var hidden=true;
    platforms.forEach(platform => {
      if(data?.platform ==platform){
        hidden=false;
      }
    });
    return hidden;
  };
  const getRomNumber=(romStr:string)=>{
    if(romStr){
      romStr=romStr.replace("GB","").replace("GB","").replace("MB","");
      var numArr= romStr.split("/");
      var num= Number(numArr[0])*100/Number(numArr[1]);
      return num;
    }else{
      return 0;
    }
  }
  const getBatteryNumber=(romStr:string)=>{
    if(romStr){
      romStr=romStr.replace("%","");
      return Number(romStr);
    }else{
      return 0;
    }
  }

  const onUserChange = (value: any, option: any) => {
    setUserName(value ? option.children : "");
  };

  const onUserSelect = (value: any, option: any) => {
    setUserSelect(value);
  };

  const handleCancel2 = () => {
    setIsModalVisible2(false);
    form.resetFields();
  };
   const handleOrgCancel = () => {
    setOrgVisible(false);
    orgForm.resetFields();
  };
  const handleUserCancel = () => {
    setUserVisible(false);
    userForm.resetFields();
  };
  const handleAssetCancel = () => {
    setAssetVisible(false);
    setImageUrl("");
    assetForm.resetFields();
  };

  const showNoteModel = () => {
    setNoteVisible(true);
  }
  const handleNoteOK = () => {
    noteForm.validateFields().then((res) => {
      data.remark = res.remark.trim();
      data.remark2 = res.remark2.trim();
      setNoteVisible(false);
      setDeviceRemarks(data.id, {remark: data.remark, remark2: data.remark2}).then(() => {
        notification.success({message: t("保存成功")});
      }) 
    })
  }
  const handleNoteCancel = () => {
    setNoteVisible(false);
    noteForm.resetFields();
  }

  const onExclude = (checked: boolean, deviceId: any) => {
    deviceExcludes(deviceId, {isExcluded: checked}).then(() => {
      data.isExcluded = checked;
      notification.success({message: t("操作成功")});
    })
  }

  const viewBypassCode = () => {
    getDeviceBypassCode(id).then(res => {
      setActivationlockVisible(true);
      setBypassCode(res);
    })
  }

  const viewFDECode = () => {
    setFDEFileVisible(true);
  }

  const onChange = (value: any, labelList: React.ReactNode[], extra: any) => {
    var orgName = labelList[0]?.toString();
    setOrgName(orgName);
  }


  const beforeUpload = (file: File) => {
    // const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    // if (!isJpgOrPng) {
    //   notification.error({ message: t("You can only upload JPG/PNG file!") });
    // }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      notification.error({ message: t("Image must smaller than 2MB!") });
    }
    return false;
  };

  function getBase64(img: any, callback: any) {
    const reader = new FileReader();
    reader.addEventListener("load", () => {
      callback(reader.result);
      console.log(reader);
    });
    reader.readAsDataURL(img);
  }

  const handleChange = (info: any) => {
    getBase64(info.file, (imageUrl: any) => {
      setImageUrl(imageUrl);
    });
  };
  
  const filter = (inputValue: string, path: DefaultOptionType[]) =>
    path.some(
      option => (option.label as string).toLowerCase().indexOf(inputValue.toLowerCase()) > -1,
    );
  
  const clearLock = () =>{
    iosDeviceOperation(id, {commandType: 57}).then(
      () => { 
        notification.success({message: t("清除成功")}); 
      },
      () => { notification.error({message: t("清除失败")}) },
    )
  }

  return (<>
    <Row gutter={16} style={{marginBottom: "15px"}}>
      <Col span={8}>
        <Card title={
          <>
            <img src="/images/icon1.svg" alt="" style={{margin: "0 10px 0 0"}}/>
            <b>{t("设备信息")}</b>
          </>
        } className="shadow-sm bg-light" style={{height: "470px"}}>
          <table className="table">
            <tbody>
              {/* <tr hidden={isHidden(['IOS',"macOS"])}>
                <td>设备名称</td>
                <td>
                  {data?.deviceName} 
                  <EditOutlined 
                    className="col-md-2"  
                    onClick={()=>{
                      setDeviceName(data?.deviceName);
                      setDeviceNameVisible(true);
                      gaEvent("deviceDetailEnrollInfo","onClick","modifyName");
                    }}
                  ></EditOutlined>
                </td>
              </tr> */}
              <tr>
                <td style={{minWidth: "80px"}}>{t("设备平台")}</td>
                <td>{data?.platform === "IOS" ? "iOS" : data?.platform}</td>
              </tr>
              <tr hidden={isHidden(['Android'])}>
                <td>{t("是否root")}</td>
                <td>{data?.androidDeviceInfo?.isRoot === true ? t("是") : t("否")}</td>
              </tr>
              {/* <tr hidden={isHidden(['IOS'])}>
                <td>{t("是否越狱")}</td>
                <td>{data?.iosDeviceInfo?.isJailbreak === true ? t("是") : t("否")}</td>
              </tr> */}
              <tr>
                <td>{t("型号")}</td>
                <td>{data?.model}</td>
              </tr>
              <tr>
                <td>{t("设备类型")}</td>
                <td>{t(DeviceTypes[data?.deviceType??"Phone"])}</td>
              </tr>
              <tr>
                <td>{t("系统版本")}</td>
                <td>{data?.osVersion}</td>
              </tr>
              <tr hidden={isHidden(["macOS"])}>
                <td>{t("芯片类型")}</td>
                <td>{data?.chipType}</td>
              </tr>
              <tr hidden={isHidden(['IOS',"macOS"])}>
                <td>
                  <div style={{display: "flex"}}>
                    <span>{t("系统升级状态")}</span>
                    <Tooltip title={t("操作系统更新后状态有延迟，请稍后刷新查看")}>
                      <span style={{marginLeft: "5px", display: "flex", alignItems: "center"}}><InfoCircleOutlined /></span>
                    </Tooltip>
                  </div>
                </td>
                <td>{data?.osUpdateStatus ? data?.osUpdateStatus : t("无")}</td>
              </tr>
              <tr hidden={isHidden(['IOS',"macOS"])}>
                <td>{t("监督模式")}</td>
                <td>
                  <Badge color={data?.iosDeviceInfo?.supervisedModel ? "green" : "red"} text={data?.iosDeviceInfo?.supervisedModel ? t("启用") : t("未启用")} />
                </td>
              </tr>
              <tr hidden={isHidden(['IOS','Android'])}>
                <td>{t("单应用模式")}</td>
                <td>
                  {/* <Badge color={data?.isSingleAppModeEnabled ? "green" : "red"} text={data?.isSingleAppModeEnabled ? t("启用") : t("未启用")} /> */}
                  <Badge color={data?.singleAppStatus == "Enabled" ? "green" : data?.singleAppStatus == "Disabled" ? "red" : "yellow"} text={data?.singleAppStatus == "Enabled" ? t("启用") : data?.singleAppStatus == "Disabled" ? t("未启用"): t("进行中")} />
                </td>
              </tr>
              <tr hidden={isHidden(['IOS'])}>
                <td>{t("丢失模式")}</td>
                <td>
                  {/* <Badge color={data?.lostModeStatus == "Enabled" ? "green" : "red"} text={data?.iosDeviceInfo?.isMDMLostModeEnabled ? t("启用") : t("未启用")} /> */}
                  <Badge color={data?.lostModeStatus == "Enabled" ? "green" : data?.lostModeStatus == "Disabled" ? "red" : "yellow"} text={data?.lostModeStatus == "Enabled" ? t("启用") : data?.lostModeStatus == "Disabled" ? t("未启用"): t("进行中")} />
                </td>
              </tr>
              <tr hidden={isHidden(['IOS'])}>
                <td>{t("多应用模式")}</td>
                <td>
                  <Badge color={data?.multipleAppStatus == "Enabled" ? "green" : data?.multipleAppStatus == "Disabled" ? "red" : "red"} text={data?.multipleAppStatus == "Enabled" ? t("启用") : data?.multipleAppStatus == "Disabled" ? t("未启用"): t("未启用")} />
                </td>
              </tr>
              {/* <tr hidden={isHidden(['IOS'])}>
                <td>{t("激活锁")}</td>
                <td>{data?.iosDeviceInfo?.activationLock ? t("启用") : t("未启用")}</td>
              </tr> */}
              {/* <tr hidden={isHidden(['Android'])}>
                <td>设备容量</td>
                <td>{data?.androidDeviceInfo?.rom ?? "--"}</td>
              </tr>
              <tr hidden={isHidden(['Android'])}>
                <td>设备电量</td>
                <td>{data?.androidDeviceInfo?.batteryLevel ? data?.androidDeviceInfo?.batteryLevel + "%" : "--"}</td>
              </tr>
              <tr hidden={isHidden(['IOS','macOS'])}>
                <td>设备容量</td>
                <td>
                <div>
                    <div><Progress  showInfo={false} percent={getRomNumber(data?.iosDeviceInfo?.rom)} /></div>
                    <p style={{textAlign:"center"}}> {data?.iosDeviceInfo?.rom ?? "--"}</p>
                  </div>
                  </td>
              </tr>
              <tr hidden={isHidden(['IOS'])}>
                <td>设备电量</td>
                <td>
                  <div>
                    <div><Progress showInfo={false} percent={getBatteryNumber( data?.iosDeviceInfo?.batteryLevel)} /></div>
                    <p style={{textAlign:"center"}}> {data?.iosDeviceInfo?.batteryLevel ? data?.iosDeviceInfo?.batteryLevel: "--"}</p>
                  </div>
                </td>
              </tr> */}
            </tbody>
          </table>
        </Card>
      </Col>

      <Col span={8}>
        <Card title={
          <>
            <img src="/images/icon2.svg" alt="" style={{margin: "0 10px 0 0"}}/>
            <b>{t("注册信息")}</b>
          </>
        } className="shadow-sm bg-light" style={{height: "470px"}}>
          <table className="table">
            <tbody>
              <tr>
                <td style={{minWidth: "80px"}}>{t("注册状态")}</td>
                <td>
                  <Badge color={data?.status == 1 ? "green" : "red"} text={data?.status == 1 ? t('已注册') : t('未注册')} />
                </td>
              </tr>
              {/* <tr hidden={isHidden(['IOS'])}>
                <td>FCM {t("注册状态")}</td>
                <td>--</td>
              </tr> */}
              <tr>
                <td>{t("注册日期")}</td>
                <td>{data?.enrollTime ? dayjs(data?.enrollTime).format("YYYY/MM/DD") : "--"}</td>
              </tr>
              {/* <tr>
                <td>上次使用</td>
                <td>{data?.androidDeviceInfo?.enrollment?.lastCheckedIn ?? "--"}</td>
              </tr> */}
              {/* <tr>
                <td>同步时间</td>
                <td>{data?.syncTime ? data?.syncTime : "--"}</td>
              </tr> */}
              <tr>
                <td>{t("最近同步时间")}</td>
                <td>{data?.syncSuccessTime ? data?.syncSuccessTime : "--"}</td>
              </tr>
              <tr hidden={isHidden(['Android'])}>
                <td>{t("展台模式")}</td>
                <td>{data?.androidDeviceInfo?.enrollment?.kioskModeStatus ?? "--"}</td>
              </tr>
              <tr hidden={isHidden(['Android'])}>
                <td>{t("设备拥有模式")}</td>
                <td>{data?.androidDeviceInfo?.isDeviceOwner ? t("已启用") : t("未启用")}</td>
              </tr>
              {/* <tr hidden={isHidden(['IOS'])}>
                <td>single app模式</td>
                <td>{data?.isSingleAppModeEnabled ? "启用" : "未启用"}</td>
              </tr> */}
              {/* <tr hidden={isHidden(['IOS'])}>
                <td>{t("单应用模式")}</td>
                <td>{data?.isSingleAppModeEnabled ? t("启用") : t("未启用")}</td>
              </tr> */}
              {/* <tr hidden={isHidden(['IOS',"macOS"])}>
                <td>监督模式</td>
                <td>{data?.iosDeviceInfo?.supervisedModel ? "启用" : "未启用"}</td>
              </tr> */}
              {/* <tr hidden={isHidden(['IOS'])}>
                <td>{t("丢失模式")}</td>
                <td>{data?.iosDeviceInfo?.isMDMLostModeEnabled ? t("启用") : t("未启用")}</td>
              </tr> */}
              {/* <tr hidden={isHidden(['IOS'])}>
                <td>{t("激活锁")}</td>
                <td>{data?.iosDeviceInfo?.activationLock ? t("启用") : t("未启用")}</td>
              </tr> */}
              <tr hidden={isHidden(['IOS', 'macOS'])}>
                <td>{t("组织机构")}</td>
                <td>
                  {
                    data?.abmasm ? (
                      <Tooltip title={data?.abmasm} placement="bottom">
                        <span style={{display: "block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", width: i18n.language === "zh" ? "70%" : "60%"}}>{data?.abmasm}</span>
                      </Tooltip>
                    ) : "--"
                  }
                </td>
              </tr>
              <tr hidden={isHidden(['IOS', 'macOS'])}>
                <td>{t("机构管理员")}</td>
                <td>
                  {
                    data?.appleId ? (
                      <Tooltip title={data?.appleId} placement="bottom">
                        <span style={{display: "block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", width: i18n.language === "zh" ? "70%" : "60%"}}>{data?.appleId}</span>
                      </Tooltip>
                    ) : "--"
                  }
                </td>
              </tr>
              <tr hidden={isHidden(['IOS',"macOS"])}>
                <td>{t("声明式管理")}</td>
                <td>
                  <Badge color={data?.isDeclarativeEnabled ? "green" : "red"} text={data?.isDeclarativeEnabled ? t("启用") : t("未启用")} />
                </td>
              </tr>
              <tr hidden={isHidden(['macOS'])}>
                <td>{t("共享设备")}</td>
                <td>{data?.iosDeviceInfo?.activationLock=="111" ? t("是") : t("否")}</td>
              </tr>
              <tr hidden={isHidden(['IOS'])}>
                <td><span style={{lineHeight: "32px"}}>{t("激活锁")}</span></td>
                {/* <td>{data?.bypassCode ? <Button type="link" onClick={viewBypassCode} style={{padding: 0}}>{t("查看旁通码")}</Button> : "--"}</td> */}
                <td><Button type="link" onClick={viewBypassCode} style={{padding: 0}}>{t("查看旁通码")}</Button>
                  <Popconfirm 
                    title={t("确认清除激活锁?")} 
                    onConfirm={() => { clearLock() }}
                    okText={t("确认")}
                    cancelText={t("取消")}
                  >
                    <Button type="link">{t("清除激活锁")}</Button>
                  </Popconfirm>
                </td>
              </tr>
              <tr>
                <td>
                  <div style={{display: "flex"}}>
                    <span>{t("例外")}</span> 
                    <Tooltip title={t("设置例外的设备将不应用任何配置文件，取消后重新应用")}>
                      <span style={{marginLeft: "5px", display: "flex", alignItems: "center"}}><InfoCircleOutlined /></span>
                    </Tooltip>
                  </div>
                </td>
                <td><Switch key={data?.isExcluded} defaultChecked={data?.isExcluded} onChange={(checked) => { return onExclude(checked, id)}} /></td>
              </tr>
            </tbody>
          </table>
        </Card>
      </Col>

      <Col span={8}>
        <Card title={
          <>
            <img src="/images/icon3.svg" alt="" style={{margin: "0 10px 0 0"}}/>
            <b>{t("自定义属性")}</b>
          </>
        } className="shadow-sm bg-light" style={{height: "470px"}}>
          <table className="table">
            <tbody>
              <tr hidden={isHidden(['IOS',"macOS"])}>
                <td style={{minWidth: "80px"}}>{t("设备名称")}</td>
                <td>
                  {data?.deviceName} 
                  <EditOutlined 
                    className="col-md-2"  
                    style={{color: "#0d6efd"}}
                    onClick={()=>{
                      setDeviceName(data?.deviceName);
                      setDeviceNameVisible(true);
                    }}
                  ></EditOutlined>
                </td>
              </tr>
              <tr>
                <td>{t("所属部门")}</td>
                <td>
                  {data?.organizationName ?? "--"}
                  <EditOutlined
                    className="col-md-2"  
                    style={{color: "#0d6efd"}}
                    onClick={() => { showOrgModal() }}
                  ></EditOutlined>
                </td>
              </tr>
              <tr>
                <td>{t("静态设备组")}</td>
                <td>
                  {/* <a className="underline" onClick={() => { showModal2(); gaEvent("deviceDetailEnrollInfo", "onClick", "showModal2"); }}>
                    {data?.tagValues?.length == 0 ? "--" : data?.tagValues?.map((item: any, i: number) => `${item}${i <data.tagValues?.length - 1 ? "，" : ""}`)}
                  </a> */}
                  {data?.tagValues?.length == 0 ? "--" : data?.tagValues?.map(
                    (item: any, i: number) => `${item}${i <data.tagValues?.length - 1 ? "，" : ""}`
                  )}
                  <EditOutlined
                    className="col-md-2"  
                    style={{color: "#0d6efd"}}
                    onClick={() => { showModal2() }}
                  ></EditOutlined>
                </td>
              </tr>
              <tr>
                <td>{t("智能设备组")}</td>
                <td>
                  {data?.smartGroups}
                </td>
              </tr>
              <tr>
                <td>{t("用户")}</td>
                <td> 
                  {/* <a className="underline" onClick={() => { showModal2(); gaEvent("deviceDetailEnrollInfo", "onClick", "showModal2"); }}>{data?.userName ? data?.userName != '' ? data?.userName : "--" : "--"}</a> */}
                  {data?.userName ? data?.userName != '' ? data?.userName : "--" : "--"}
                  <EditOutlined
                    className="col-md-2"  
                    style={{color: "#0d6efd"}}
                    onClick={() => { showUserModal() }}
                  ></EditOutlined>
                </td>
              </tr>
              <tr>
                <td>{t("资产组")}</td>
                <td>
                  {/* <a className="underline" onClick={() => { showAssetModal(); gaEvent("deviceDetailEnrollInfo", "onClick", "showModal"); }}>{data?.assetName ? data?.assetName : "--"}</a>
                  <br />
                  <a className="underline" onClick={() => { showAssetModal(); gaEvent("deviceDetailEnrollInfo", "onClick", "showModal"); }}>{data?.assetBeginDate ? data?.assetBeginDate : "--"}</a> */}
                  {data?.assetName ? data?.assetName : "--"}
                  <EditOutlined
                    className="col-md-2"  
                    style={{color: "#0d6efd"}}
                    onClick={() => { showAssetModal() }}
                  ></EditOutlined>
                </td>
              </tr>
              <tr>
                <td>{t("购买时间")}</td>
                <td>
                  {data?.assetBeginDate ? data?.assetBeginDate : "--"}
                  <EditOutlined
                    className="col-md-2"  
                    style={{color: "#0d6efd"}}
                    onClick={() => { showAssetModal() }}
                  ></EditOutlined>
                </td>
              </tr>
              <tr>
                <td>{t("备注")}</td>
                <td>
                  {/* <TextArea placeholder="设备备注信息（50字以内）" onClick={(e)=>{ showNoteModel(); e.currentTarget.blur();}} value={data?.remark}></TextArea> */}
                  {data?.remark ?? "--"}
                  <EditOutlined
                    className="col-md-2"  
                    style={{color: "#0d6efd"}}
                    onClick={() => { showNoteModel() }}
                  ></EditOutlined>
                </td>
              </tr>
              <tr>
                <td>{t("备注")+ "2"}</td>
                <td>
                  {data?.remark2 ?? "--"}
                  <EditOutlined
                    className="col-md-2"  
                    style={{color: "#0d6efd"}}
                    onClick={() => { showNoteModel() }}
                  ></EditOutlined>
                </td>
              </tr>
            </tbody>
          </table>
        </Card>
      </Col>

      <Col span={8} className="mt-4">
        <Card title={
          <>
            <img src="/images/icon4.svg" alt="" style={{margin: "0 10px 0 0"}}/>
            <b>{t("硬件明细")}</b>
          </>
        } className="shadow-sm bg-light" style={{height: "520px"}}>
          <table className="table">
            <tbody>
              <tr>
                <td style={{minWidth: "80px"}}>{t("序列号")}</td>
                <td>{data?.serialNo}</td>
              </tr>
              <tr hidden={isHidden(['IOS', 'macOS'])}>
                <td>UDID</td>
                <td>{data?.udid}</td>
              </tr>
              <tr hidden={isHidden(['Android'])}>
                <td>IMEI</td>
                <td>{data?.androidDeviceInfo?.imei}</td>
              </tr>
              <tr hidden={isHidden(['IOS', 'macOS'])}>
                <td>IMEI</td>
                <td>{data?.iosDeviceInfo?.imei}</td>
              </tr>
              <tr>
                <td>{t("设备")} ID</td>
                <td>{data?.id}</td>
              </tr>
              <tr hidden={isHidden(['Android'])}>
                <td>{t("设备容量")}</td>
                <p>{data?.androidDeviceInfo?.rom ?? "--"}</p>
              </tr>
              <tr hidden={isHidden(['Android'])}>
                <td>{t("设备电量")}</td>
                <td>
                  <div>
                    <div><Progress showInfo={false} percent={getBatteryNumber(data?.androidDeviceInfo?.batteryLevel)}/></div>
                    <p>{data?.androidDeviceInfo?.batteryLevel ? data?.androidDeviceInfo?.batteryLevel + "%" : "--"}</p>
                  </div>
                </td>
              </tr>
              <tr hidden={isHidden(['IOS','macOS'])}>
                <td>{t("设备容量")}</td>
                <td>
                <div>
                  <div><Progress  showInfo={false} percent={getRomNumber(data?.iosDeviceInfo?.rom)} /></div>
                  <p> {data?.iosDeviceInfo?.rom ?? "--"}</p>
                </div>
                </td>
              </tr>
              <tr hidden={isHidden(['IOS'])}>
                <td>{t("设备电量")}</td>
                <td>
                  <div>
                    <div><Progress showInfo={false} percent={getBatteryNumber( data?.iosDeviceInfo?.batteryLevel)} /></div>
                    <p> {data?.iosDeviceInfo?.batteryLevel ? data?.iosDeviceInfo?.batteryLevel: "--"}</p>
                  </div>
                </td>
              </tr>                
            </tbody>
          </table>
        </Card>
      </Col>

      <Col span={8} className="mt-4">
        <Card title={
          <>
            <img src="/images/icon5.svg" alt="" style={{margin: "0 10px 0 0"}}/>
            <b>{isHidden(['IOS', 'Android']) ? t("安全信息") : t("网络信息")}</b>
          </>
        } className="shadow-sm bg-light" style={{height: "520px"}}>
          <table className="table">
            <tbody>
              <tr hidden={isHidden(['IOS', 'Android'])}>
                <td>{t("SIM卡")} 1 {t("手机号码")}</td>
                <td>{data?.networkInfo?.phoneNo ?? "--"}</td>
              </tr>
              <tr hidden={isHidden(['IOS', 'Android'])}>
                <td>{t("SIM卡")} 1 IMEI</td>
                <td>{data?.networkInfo?.imeisiM1 ?? "--"}</td>
              </tr>
              <tr hidden={isHidden(['IOS', 'Android'])}>
                <td>{t("SIM卡")} 1 {t("运营商")}</td>
                <td>{data?.networkInfo?.ispsiM1 ?? "--"}</td>
              </tr>
              <tr hidden={isHidden(['IOS', 'Android'])}>
                <td>{t("SIM卡")} 1 ICCID</td>
                <td>{data?.networkInfo?.iccid ?? "--"}</td>
              </tr>
              {/* <tr hidden={isHidden(['IOS', 'Android'])}>
                <td>{t("SIM卡")} 1 MEID</td>
                <td>{data?.networkInfo?.meid ?? "--"}</td>
              </tr> */}
              <tr hidden={isHidden(['IOS', 'Android'])}>
                <td>{t("SIM卡")} 2 {t("手机号码")}</td>
                <td>{data?.networkInfo?.phoneNo2 ?? "--"}</td>
              </tr>
              <tr hidden={isHidden(['IOS', 'Android'])}>
                <td>{t("SIM卡")} 2 IMEI</td>
                <td>{data?.networkInfo?.imeisiM2 ?? "--"}</td>
              </tr>
              <tr hidden={isHidden(['IOS', 'Android'])}>
                <td>{t("SIM卡")} 2 {t("运营商")}</td>
                <td>{data?.networkInfo?.ispsiM2 ?? "--"}</td>
              </tr>
              <tr hidden={isHidden(['IOS', 'Android'])}>
                <td>{t("SIM卡")} 2 ICCID</td>
                <td>{data?.networkInfo?.icciD2 ?? "--"}</td>
              </tr>
              {/* <tr hidden={isHidden(['IOS', 'Android'])}>
                <td>{t("SIM卡")} 2 MEID</td>
                <td>{data?.networkInfo?.meiD2 ?? "--"}</td>
              </tr> */}
              {/* <tr hidden={isHidden(['IOS', 'Android'])}>
                <td>IP {t("地址")}</td>
                <td>{data?.networkInfo?.ipAddress ?? "--"}</td>
              </tr> */}
              <tr hidden={isHidden(['IOS', 'macOS', 'Android'])}>
                <td>WiFi MAC {t("地址")}</td>
                <td>{data?.networkInfo?.wiFiMAC ?? "--"}</td>
              </tr>
              <tr hidden={isHidden(["macOS"])}>
                <td>
                  {t("文件保险箱")}
                </td>
                <td style={{ display: 'flex', alignItems: 'center' }}>
                  <Badge 
                    style={{paddingLeft:'0px'}} 
                    color={data?.fdeEnable ? "green" : "red"} 
                    text={data?.fdeEnable ? t("启用") : t("未启用")} 
                  />
                  { data?.fdeEnable && 
                    <a 
                    style={{ 
                      color:'#46586e', 
                      marginRight: '10px',
                      marginLeft: 'auto',
                    }} 
                    onClick={viewFDECode} >
                      {t("查看密钥")}
                    </a> 
                  }
                </td>
              </tr>
              <tr hidden={isHidden(['macOS'])}>
                <td>SIP</td>
                <td>
                  <Badge 
                    style={{paddingLeft:'0px'}} 
                    color={data?.sipEnabled ? "green" : "red"} 
                    text={data?.sipEnabled ? t("启用") : t("未启用")} 
                  />
                </td>
              </tr>
              <tr hidden={isHidden(['macOS'])}>
                <td>{t("恢复锁")}</td>
                <td>
                  <Badge 
                    style={{paddingLeft:'0px'}} 
                    color={data?.isRecoveryLockEnabled ? "green" : "red"} 
                    text={data?.isRecoveryLockEnabled ? t("启用") : t("未启用")} 
                  />
                </td>
              </tr>
              <tr hidden={isHidden(['macOS'])}>
                <td>{t("远程桌面")}</td>
                <td>
                  <Badge 
                    style={{paddingLeft:'0px'}} 
                    color={data?.remoteDesktopEnabled ? "green" : "red"} 
                    text={data?.remoteDesktopEnabled ? t("启用") : t("未启用")} 
                  />
                </td>
              </tr>
              <tr hidden={isHidden(['macOS'])}>
                <td>{t("防火墙")}</td>
                <td>
                  <Badge 
                    style={{paddingLeft:'0px'}} 
                    color={data?.firewallEnabled ? "green" : "red"} 
                    text={data?.firewallEnabled ? t("启用") : t("未启用")} 
                  />
                </td>
              </tr>
              {/* <tr hidden={isHidden(['IOS', 'Android'])}>
                <td>WiFi SSID</td>
                <td>{data?.networkInfo?.wiFiSSID ?? "--"}</td>
              </tr> */}
            </tbody>
          </table>
        </Card>
      </Col>

      <Col span={8} className="mt-4">
        <Card title={
          <>
            <img src="/images/icon6.svg" alt="" style={{margin: "0 10px 0 0"}}/>
            <b>{t("最近位置")}</b>
          </>
        } className="shadow-sm bg-light" style={{height: "520px"}} extra={<a className="a" onClick={()=>{getLocations();gaEvent("deviceDetailOverview","onClick","getLocations")}}>{t("同步位置")}</a>}>
          <table className="table">
            <tbody>
              {
                Array.isArray(locations) ?
                  locations.map((location, index) => <tr key={index}><td><a className="a" onClick={()=>{showModal(location);gaEvent("deviceDetailOverview","onClick","查看地图")}}>{t("查看地图")}</a></td><td>{location.createdTime}</td></tr>) : <tr></tr>
              }
            </tbody>
          </table>
        </Card>
      </Col>
      {/* <Col span={12} className="mt-4">
        <Card title={<b>远程查看</b>} className="shadow-sm bg-light">
          <table className="table">
            <tbody>
              <tr>

              </tr>
            </tbody>
          </table>
        </Card>
      </Col> */}
    </Row>
    <Modal
      maskClosable={false}
      title={t("修改设备名称")}
      destroyOnClose={true}
      open={deviceNameVisible}
      onOk={deviceNameModify}
      onCancel={()=>{setDeviceNameVisible(false)}}
      okText={t("确认")}
      cancelText={t("取消")}
    >
      <Input value={deviceName} onChange={(e)=>{setDeviceName(e.target.value.trim())}}></Input>
    </Modal>
    <Modal
      maskClosable={false}
      title={t("位置")}
      destroyOnClose={true}
      open={isModalVisible}
      footer={null}
      onCancel={handleOk}
      width={'50%'}
      okText={t("确认")}
      cancelText={t("取消")}
    >
      <div style={{ width: '100%', height: '500px' }}>
        <APILoader akay="G1rDtTzcrNn7iogh3mwy1X9a9t2NGZSs">
          <Map
            // 滚轮滑动放大缩小地图
            enableScrollWheelZoom
            // 缩放等级
            zoom={17}
            center={{ lng: marker?.longitude, lat: marker?.latitude }}
            // 添加地图控件
            widget={[
              // 'GeolocationControl',
              {
                name: 'NavigationControl',
                options: (BMap) => {
                  return {
                    offset: new BMap.Size(20, 5),
                    showZoomInfo: false,
                    enableGeolocation: true,
                  }
                }
              }
            ]}
          >
            <Marker position={{ lng: marker?.longitude, lat: marker?.latitude }} animation={1} type="loc_red" />
          </Map>
        </APILoader>
      </div>
    </Modal>
    <Modal
      maskClosable={false}
      title={t("修改设备组")}
      destroyOnClose={true}
      open={isModalVisible2}
      onOk={handleOk2}
      onCancel={handleCancel2}
      okText={t("确认")}
      cancelText={t("取消")}
    >
      <Form
        layout="horizontal"
        form={form}
        labelCol={{ span: 4 }}
        initialValues={{ tags: data?.currentTags }}
      >
        <List name="tags">
          {(fields, { add, remove }) => (
            <>
              {fields.map((field) => (
                <Item key={field.key} labelCol={{ span: 4 }} label={t("设备组")}>
                  <Row justify="space-between">
                    <Col span="21">
                      <Item noStyle
                        {...field}
                        name={[field.name, "tag"]}
                        // fieldKey={[field.fieldKey, "tag"]}
                      >
                        <Cascader options={tagOptions} 
                          placeholder={t("请选择")} 
                          showSearch={{ filter }}
                          onSearch={value => console.log(value)}
                        />
                      </Item>
                    </Col>
                    <Col>
                      <Button type="dashed" onClick={() => { remove(field.name); }}>-</Button>
                    </Col>
                  </Row>
                </Item>
              ))}
              <Form.Item wrapperCol={{ offset: 4 }}>
                <Button type="dashed" onClick={() => { add(); }} block>
                  {t("添加设备组")}
                </Button>
              </Form.Item>
            </>
          )}
        </List>
      </Form>
    </Modal>
    <Modal
      maskClosable={false}
      title={t("修改用户")}
      destroyOnClose={true}
      open={userVisible}
      onOk={handleUserOk}
      onCancel={handleUserCancel}
      okText={t("确认")}
      cancelText={t("取消")}
    >
      <Form
        layout="horizontal"
        form={userForm}
        labelCol={{ span: 4, }}
        initialValues={{ userSelect: userSelect, userId: data?.userId }}
      >
        {/* <Item label={t("部门")} name="organization" rules={[{ required: false }]}>
          <TreeSelect treeData={orgOptions} treeDefaultExpandAll onChange={onChange}></TreeSelect>
        </Item> */}
        <Item name="userSelect" wrapperCol={{ offset:2}}  rules={[{ required: true }]}>
          <Select onChange={onUserSelect}>
            <Select.Option value="Create">{t("新建用户")}</Select.Option>
            <Select.Option value="Select">{t("从列表选择")}</Select.Option>
          </Select>
        </Item>
        {(userSelect == "Select") && <Item label={t("用户")} name="userId">
          <Select
            showSearch
            allowClear
            // style={{ width: 200 }}
            placeholder={t("请选择用户")}
            optionFilterProp="children"
            onChange={onUserChange}
            filterOption={(input, option) =>
              option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {
              Array.isArray(users) ?
                users.map(user => <Select.Option key={user.id} value={user.id}>{user.name}</Select.Option>) : ""
            }
          </Select>
        </Item>}
        {(userSelect == "Create") && <><Item label={t("姓名")} name="name"  rules={[{ required: true }]}>
            <Input></Input>
          </Item>
          <Item label={t("邮箱")} name="email">
            <Input></Input>
          </Item>
          <Item label={t("电话")} name="phone">
            <Input></Input>
          </Item>
          <Item label={t("工号")} name="number">
            <Input></Input>
          </Item>
          <Item label={t("部门")} name="orgName">
            <Input></Input>
          </Item>
          <Item label={t("备注")} name="remark">
            <Input></Input>
          </Item>
        </>
        }
      </Form>
    </Modal>
    <Modal
      maskClosable={false}
      title={t("修改部门")}
      destroyOnClose={true}
      open={orgVisible}
      onOk={handleOrgOk}
      onCancel={handleOrgCancel}
      okText={t("确认")}
      cancelText={t("取消")}
    >
      <Form
        layout="horizontal"
        form={orgForm}
        labelCol={{ span: 4, }}
        initialValues={{ }}
      >
        <Item label={t("部门")} name="organization" rules={[{ required: false }]}>
          <TreeSelect placeholder={t("选择部门")} treeData={orgOptions} treeDefaultExpandAll onChange={onChange} allowClear></TreeSelect>
        </Item>
      </Form>
    </Modal>
    <Modal
      maskClosable={false}
      title={t("设置资产组")}
      destroyOnClose={true}
      open={assetVisible}
      onOk={handleAssetOk}
      onCancel={handleAssetCancel}
      okText={t("确认")}
      cancelText={t("取消")}
    >
      <Form
        layout="horizontal"
        form={assetForm}
        labelCol={{ span: i18n.language === "zh" ? 4 : 8 }}
        initialValues={{
          assetId: "", 
          assetBeginDate: "",
          invoice: "",
          invoiceFile: "",
          extensions: [{
            assetType: "Repair",
            assetDate: "",
            amount: "",
            remark: "",
          }], 
        }}
      >
        <div style={{fontSize: 16, marginBottom: 16}}>{t("购买成本")}</div>
        <Item label={t("资产组")} name="assetId" rules={[{required: true}]}>
          <Select
            showSearch
            // style={{ width: 200 }}
            placeholder={t("请选择资产组")}
            optionFilterProp="children"
            // onChange={onAssertChange}
            filterOption={(input, option: any) =>
              option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {
              Array.isArray(assetList) ?
                assetList?.map(ass => <Select.Option key={ass.id} value={ass.id}>{ass.name}</Select.Option>) : ""
            }
          </Select>
        </Item>
        <Item label={t("购买时间")} name="assetBeginDate" rules={[{required: true}]}>
          <DatePicker format={dateFormat} picker="month" style={{width: "100%"}} placeholder={t("请选择月份")}/>
        </Item>
        <Item label={t("发票信息")} name="invoice">
          <Input placeholder={t("发票号")}></Input>
        </Item>
        <Item
          label={t("发票附件")}
          name="invoiceFile"
          // valuePropName="fileList"
          // getValueFromEvent={normFile}
          extra={t("支持jpg，jpeg，png，pdf格式，文件不大于1MB")}
        >
          <Upload
            accept="jpg,jpeg,png,pdf"
            listType="picture-card"
            showUploadList={false}
            beforeUpload={beforeUpload}
            onChange={handleChange}
            maxCount={1}
          >
            {imageUrl ? (
              <img src={imageUrl} alt="avatar" style={{ width: "100%" }} />
            ) : (
              <UploadOutlined />
            )}
          </Upload>
        </Item>
        <div style={{fontSize: 16, marginBottom: 16}}>{t("其它成本")}</div>
        <List name="extensions">
          {(fields, { add, remove }) => (
            <>
              {fields.map((field) => {
                return (<>
                  <Row style={{display: "flex", flexFlow: "row nowrap"}}>
                    <Col>
                      <Row>
                        <Col span={12}>
                          <Item key={`${field.key}_1`} label={t("成本类型")} name={[field.name, "assetType"]} labelCol={{span: 9}} rules={[{required: true}]}>
                            <Select style={{width: "90%"}}>
                              <Select.Option key={`${field.key}_11`} value="Repair">{t("维修")}</Select.Option>
                              <Select.Option key={`${field.key}_12`} value="Other">{t("其它")}</Select.Option>
                            </Select>
                          </Item>
                        </Col>
                        <Col span={12}>
                          <Item key={`${field.key}_2`} label={t("时间")} name={[field.name, "assetDate"]} labelCol={{span: i18n.language === "zh" ? 6 : 8}} rules={[{required: true}]}>
                            <DatePicker format={dateFormat2} picker="date" style={{width: "90%"}} placeholder={t("请选择")}/>
                          </Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col span={12}>
                          <Item key={`${field.key}_3`} label={t("费用")} name={[field.name, "amount"]} labelCol={{span: 9}} rules={[{required: true}]}>
                            <InputNumber style={{width: "90%"}}></InputNumber>
                          </Item>
                        </Col>
                        <Col span={12}>
                          <Item key={`${field.key}_4`} label={t("备注")} name={[field.name, "remark"]} labelCol={{span: i18n.language === "zh" ? 6 : 8}}>
                            <Input style={{width: "90%"}}></Input>
                          </Item>
                        </Col>
                      </Row>
                    </Col>
                    <Col>
                      <Button type="dashed" onClick={() => { remove(field.name) }}>-</Button>
                    </Col>
                  </Row>
                </>)
              })}
              <Form.Item wrapperCol={{ offset: 4 }}>
                <Button type="dashed" onClick={() => { add() }} block>+</Button>
              </Form.Item>
            </>
          )}
        </List>
      </Form>
    </Modal>
    <Modal
      maskClosable={false}
      title={t("设置备注信息")}
      destroyOnClose={true}
      open={noteVisible}
      onOk={handleNoteOK}
      onCancel={handleNoteCancel}
      okText={t("确认")}
      cancelText={t("取消")}
    >
      <Form
        layout="horizontal"
        form={noteForm}
        initialValues={{remark: data?.remark, remark2: data?.remark2}}
      >
        <Item label={<span>&nbsp;<Translation>{t => {return t("备注")}}</Translation></span>} name="remark">
          <TextArea 
            placeholder={t("设备备注信息(50字以内)")} 
            maxLength={50} 
            showCount
          ></TextArea>
        </Item>
        <Item label={t("备注")+"2"} name="remark2">
          <TextArea 
            placeholder={t("设备备注信息(50字以内)")} 
            maxLength={50} 
            showCount
          ></TextArea>
        </Item>
      </Form>
    </Modal>
    <Modal
      width={700}
      // confirmLoading={loding}
      maskClosable={false}
      title={t("绕过激活锁")}
      destroyOnClose={true}
      open={ActivationlockVisible}
      onOk={()=>{
        setActivationlockVisible(false)
      }}
      onCancel={()=>{
        setActivationlockVisible(false)
      }}
      okText={t("确认")}
      cancelText={t("取消")}
    >   
      <p style={{ fontSize: 16, color: "#6D6D6D" }}>*{t("设备还原后重新激活时,需要输入与设备绑定的Apple ID和密码。将Apple ID位置空着,在密码位置输入绕过激活码继续激活步骤。")}{t("绕过激活码")}:</p>
      {/* <p style={{ fontSize: 28, textAlign: "center", fontWeight: 700 }}>{user.account.role === "SuperAdmin" ? data?.bypassCode : t("请联系超级管理员查看")}</p> */}
      <p style={{ fontSize: 28, textAlign: "center", fontWeight: 700 }}>{bypassCode}</p>
      {/* <Row justify="center" align="middle">
        <Col >
          <Popconfirm 
            title={t("确认清除激活锁?")} 
            onConfirm={() => { clearLock() }}
            okText={t("确认")}
            cancelText={t("取消")}
          >
            <Button className="ant-btn ant-btn-primary">{t("清除激活锁")}</Button>
          </Popconfirm>
        </Col>
      </Row> */}
    </Modal>
    <Modal
      width={700}
      maskClosable={false}
      title={t("文件保险箱密钥")}
      destroyOnClose={true}
      open={fdeFileVisible}
      onOk={()=>{
        setFDEFileVisible(false)
      }}
      onCancel={()=>{
        setFDEFileVisible(false)
      }}
      okText={t("确认")}
      cancelText={t("取消")}
    >
      <p style={{ fontSize: 28, textAlign: "center", fontWeight: 700 }}>{data?.fdeRecoveryKey}</p>
    </Modal>
  </>);
};
